// extracted by mini-css-extract-plugin
module.exports = {"app":"style_app__3wgvW","app__background_dark":"style_app__background_dark__25mtH","app__background_light":"style_app__background_light__1-Pbo"};